import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
// Translation files
import en from './locales/en.json';
import fa from './locales/fa.json';
import es from './locales/es.json';

const resources = {
  en: {
    translation: en
  },
  fa: {
    translation: fa
  },
  es: {
    translation: es
  }
};

// First paint is always English so streamed HTML and hydration match.
// A stored language is applied after hydration.
i18n
  .use(initReactI18next)
  .init({
    resources,
    lng: 'en',
    fallbackLng: 'en',
    interpolation: {
      escapeValue: false
    },
    react: {
      useSuspense: false
    }
  });

export function applyStoredLanguage() {
  if (typeof window === 'undefined') return;
  try {
    const stored = window.localStorage.getItem('i18nextLng');
    if (!stored) return;
    const code = stored.split('-')[0];
    if (code && code !== i18n.language) {
      i18n.changeLanguage(code);
    }
  } catch (error) {
    void error;
  }
}

export default i18n; 